module.exports = __webpack_public_path__ + "static/media/wordDoc.dd601cb1.png";